import { MetaData, Scan } from "@qid/core";

export class User extends MetaData {
  name: string = '';
  email: string = '';
  phoneNumber?: string = '';
  countryCode?: string;
  countryIsoCode?: string;
  displayPictureUrl: string = '';
  defaultOrgId?: string;
  isOnboarded?: boolean;
  createdByDevice?: string;
  createdByScan?: Scan
  averageRating: number;
  totalReviews: number;
  isVerified: boolean = false;
  isEmailVerified: boolean = false;
  constructor() {
    super();
  }
}
